import axios, {AxiosError} from "axios";
import {BASEURL} from './services'
import {encryptPayloadPasswords} from '../utils/passwordEncryption'

axios.defaults.baseURL = BASEURL;

const apiClient = axios.create({
  baseURL: BASEURL,
});

type AuthStore = {
  access?: string
  api_token?: string
}

const getAuthTokens = (): AuthStore | null => {
  try {
    return JSON.parse(localStorage.getItem('auth') || 'null')
  } catch {
    return null
  }
}

const clearAuthSession = () => {
  localStorage.removeItem('auth')
  window.location.href = '/admin/login'
}

const getAccessToken = () => {
  const auth = getAuthTokens()
  return auth?.access || auth?.api_token
}

apiClient.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken()
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearAuthSession()
    }

    return Promise.reject(error)
  }
)

export const getApi = (path: string) => apiClient.get(path);

export const postApi = async (path: string, data: object) =>
  apiClient.post(path, await encryptPayloadPasswords(data));

export const putApi = async (path: string, data: object) =>
  apiClient.put(path, await encryptPayloadPasswords(data));

export const patchApi = async (path: string, data: object) =>
  apiClient.patch(path, await encryptPayloadPasswords(data));

export const deleteApi = (path: string, data: object) =>
  apiClient.delete(path, { data });
